// extracted by mini-css-extract-plugin
export var exit = "_1-3";
export var notificationContainer = "_1-1";
export var notificationStack = "_1-0";
export var shrinkFadeOut = "_1-4";
export var slideInUp = "_1-2";